import { render, staticRenderFns } from "./pRange.vue?vue&type=template&id=0bb135f4&scoped=true&"
import script from "./pRange.vue?vue&type=script&lang=js&"
export * from "./pRange.vue?vue&type=script&lang=js&"
import style0 from "./pRange.vue?vue&type=style&index=0&id=0bb135f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb135f4",
  null
  
)

export default component.exports